<script>
    export let title = 'Button title';
    export let link = '#';
    export let cssClass = 'default';
    export let singleButton = true;
</script>

<style>
    a {
        line-height: 1.3;
        -webkit-font-smoothing: antialiased;
        font-size: 14px;
        font-weight: 700;
        text-transform: uppercase;
        background-color: #1c78c7;
        border: 2px solid #1c78c7;
        border-radius: 2px;
        box-shadow: 0 4px 11px rgba(0,0,0,.25);
        color: #fff;
        padding: 12px;
        white-space: nowrap;
        text-decoration: none;
    }

    a:hover {
        background-color: #1866a9;
    }

    .outlined {
        background-color: transparent;
        box-shadow: none;
        color: #1c78c7;
    }

    .outlined:hover {
        background-color: transparent;
        color: #1866a9;
    }
</style>

<a href="{link}" class="{cssClass} block lg:inline-block m-4 {singleButton ? 'lg:mx-0' : 'lg:mx-2'}">{title}</a>